import React from "react";
import FeedbackModal from "./FeedbackModal"; // Make sure the path matches your project structure

export default function AppHeader({
  setShowHistoryMobile,
  showFeedback,
  feedbackText,
  setFeedbackText,
  feedbackType,
  setFeedbackType,
  setShowFeedback,
  handleSubmitFeedback,
  showFeedbackSuccess,
  onHomeClick
}) {
  return (
    <>
      <div className="aa-header">
        <div 
          className="aa-brand-premium" 
          onClick={() => {
            if (typeof onHomeClick === "function") {
              onHomeClick();
            } else {
              window.location.href = "/";
            }
          }}
          style={{ cursor: "pointer" }}
          title="Go to Home"
        >
          <div className="logo-wrapper-elevated">
            <img src="./logo.png" alt="Agni Tutor logo" className="brand-logo-img" />
            <div className="logo-glass-shine"></div>
          </div>
          
          <div className="brand-text-block">
            <h1 className="brand-title-main">
              <span className="accent-color">Agni</span> Tutor
            </h1>
            <div className="brand-tagline"> 
              Learn Better & Smarter
            </div>
          </div>
        </div> 

        <div className="history-btn-right">  
                 
          <button 
            className="mobile-history-btn" 
            onClick={() => {
              if (typeof setShowHistoryMobile === "function") {
                setShowHistoryMobile(true);
              }
            }}
          >
            <span className="material-icons">menu</span>
          </button>
        </div>
      </div>

      <FeedbackModal
        open={showFeedback}
        feedbackText={feedbackText}
        setFeedbackText={setFeedbackText}
        feedbackType={feedbackType}
        setFeedbackType={setFeedbackType}
        onClose={() => setShowFeedback && setShowFeedback(false)}
        onSubmit={handleSubmitFeedback}
      />
      
      {showFeedbackSuccess && (
        <div className="feedback-success-toast">
          <span className="material-icons">
            check_circle
          </span>
          <div>
            <strong>Feedback Submitted</strong>
            <div>Thank you for helping improve Agni Tutor.</div>
          </div>
        </div>
      )}
    </>
  );
}